import personalwebsiteImg from "../assets/portfolio/personalwebsite.png";
import dogifyImg from "../assets/portfolio/dogify.png";
import hostdogImg from "../assets/portfolio/hostdog.png";
import carparkImg from "../assets/portfolio/carpark.png";
import ninningerImg from "../assets/portfolio/ninninger.png";
import todoImg from "../assets/portfolio/todo.png";
import netflixImg from "../assets/portfolio/netflix-clone.png";
import tictactoeImg from "../assets/portfolio/tictactoe.png";

const portfolioData = [
  {
    name: "Personal Website",
    type: "web",
    img: personalwebsiteImg,
    des: "ReactJS",
    github: "https://github.com/pjpure/pjpure.github.io",
    demo: "",
    product: "https://pjpure.github.io/",
  },
  {
    name: "Tic-Tac-Toe",
    type: "web,game",
    img: tictactoeImg,
    des: "React, Express, Typescript, ReduxToolkit, Socket.io",
    github: "https://github.com/pjpure/tic-tac-toe-game",
    demo: "",
    product: "https://tictactoe-pjpure.netlify.app/",
  },
  {
    name: "Netflix Clone",
    type: "web",
    img: netflixImg,
    des: "React, Typescript",
    github: "https://github.com/pjpure/netflix-clone",
    demo: "",
    product: "https://netflix-clone-pjpure.netlify.app/",
  },
  {
    name: "Todo",
    type: "web",
    img: todoImg,
    des: "MonogoDB, Express, React, Node, TypeScript, Redux",
    github: "https://github.com/pjpure/MERN-Stack-Todo-App",
    demo: "",
    product: "https://todo-app-pjpure.netlify.app/",
  },
  {
    name: "Dogify",
    type: "web",
    img: dogifyImg,
    des: "ReactJS, Flask, Keras",
    github: "https://github.com/pjpure/Dogify",
    demo: "https://www.youtube.com/watch?v=Haj0N2hehrs",
    product: "https://dogify.netlify.app/",
  },
  {
    name: "Hostdogs",
    type: "web",
    img: hostdogImg,
    des: "ReactJS, Django",
    github: "https://github.com/Hostdogs",
    demo: "",
    product: "https://hostdog.netlify.app/",
  },
  {
    name: "CarParking",
    type: "app",
    img: carparkImg,
    des: "Java",
    github:
      "https://github.com/pjpure/ClassDocuments/tree/main/OOP/CarParcking/testproject01",
    demo: "https://drive.google.com/file/d/10oj0SkvespgUO9Ej2jB8yTUD4WF_VsBP/view",
    product:
      "https://github.com/pjpure/ClassDocuments/tree/main/OOP/CarParcking/testproject01",
  },
  {
    name: "Ninninger",
    type: "game",
    img: ninningerImg,
    des: "C/C++",
    github: "https://github.com/pjpure/ClassDocuments/tree/main/ComFun/Game",
    demo: "https://www.youtube.com/watch?v=0WoHkXPbGPA",
    product:
      "https://drive.google.com/file/d/1HiHjTBcLXPcHWFj7VSK_E-4j4kndxnAw/view",
  },
];

export default portfolioData;
